import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

import Home from './Home';
import { ZenDash } from '../directEntry/MFEs';

export default function HomeGateway() {
  const homepageMigrationEnabled = useExperimentFlag('enable-homepage-migration', false);

  if (homepageMigrationEnabled) {
    return <Home />;
  }

  return <ZenDash exportName="EntityHome" />;
}
